<div style="display: flex; flex-direction: row; flex: 1;">
  <div id="dayControl" style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start">
    <button style="width: 100px" class="mat-nav-button" mat-stroked-button mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
        <span translate>Previous</span>
    </button>
    <button style="width: 100px" class="mat-nav-button" mat-stroked-button mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
        <span translate>Today</span>
    </button>
    <button style="width: 100px" class="mat-nav-button" mat-stroked-button mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
        <span translate>Next</span>
    </button>
  </div>
    <div id="dateDisplay" style="display: flex; flex-direction: row; flex: 1; justify-content: center; white-space:nowrap;">
        <h3 *ngIf="view == 'month'">{{month | translate}} {{year}}</h3>
        <h3 *ngIf="view == 'week'">{{ viewDate | calendarDate:(view + 'ViewTitle'):locale }}</h3>
        <h3 *ngIf="view == 'day'">{{weekday | translate}}, {{month | translate}} {{day}}, {{year}}</h3>
    </div>
  <div id="viewControl" style="display: flex; flex-direction: row; flex: 1; justify-content: flex-end" class="print-padding">
    <button style="width: 100px" class="mat-nav-button" mat-stroked-button (click)="viewChange.emit('day')" [class.active]="view === 'day'">
      <span translate>Day</span>
    </button>
    <button style="width: 100px" class="mat-nav-button" mat-stroked-button (click)="viewChange.emit('week')" [class.active]="view === 'week'">
        <span translate>Week</span>
    </button>
    <button style="width: 100px" class="mat-nav-button" mat-stroked-button (click)="viewChange.emit('month')" [class.active]="view === 'month'">
        <span translate>Month</span>
    </button>
  </div>
</div>
